<template>
    <div class="icon-btn">
        <img src="../../assets/unifyImg/tabadd.png" v-if="btnType == 'add'">
         <img src="../../assets/unifyImg/edit.png" v-if="btnType == 'edit'">
         <img src="../../assets/unifyImg/remove.png" v-if="btnType == 'del'">
         <img src="../../assets/unifyImg/binding.png" v-if="btnType == 'binding'">
    </div>
</template>

<script>
export default {
    props:['btnType'],
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.icon-btn {
    width: 20px;
    height: 20px;
}
   img {
        width: 20px;
        height: 20px;
   }
</style>